import React from "react";
import Accordion from "react-bootstrap/Accordion";

const FAQs = () => {
  const faqsData = [
    {
      question: "Do you work as a freelancer, or are you open to full-time positions?",
      answer:
        " I currently work as a freelancer and truly enjoy the flexibility and challenges it offers. However, if an exciting opportunity arises—one that brings a new, challenging experience and adds value to my professional growth—I might consider it.",
    },
    {
      question: "Do you work solo, or do you have a team?",
      answer:
        "I am a team lead and a hands-on developer. While I personally handle development, I also collaborate with a team when needed. It all depends on the project’s scope and requirements to ensure the best execution.",
    },
    {
      question: "Do your delivered projects include support and maintenance?",
      answer:
        "Yes, all projects delivered under contract come with six months of free support and maintenance. After this period, a maintenance fee is charged annually based on a percentage of the project’s cost. This ensures long-term stability and performance.",
    },
    {
      question: "Do you provide the source code for projects?",
      answer:
        " Yes, all source code belongs to the client. I always deliver the code fully documented and well-commented to ensure clarity and maintainability.",
    },
  ];

  return (
    <section id="faq" className="section bg-light">
      <div className="container">
        <div className="row gy-5">
          <div className="col-lg-6 order-1 order-lg-0 wow fadeInUp">
            {/* Heading */}
            <p className="text-center text-lg-start mb-2">
              <span className="bg-primary text-dark px-2">FAQ</span>
            </p>
            <h2 className="text-10 fw-600 text-center text-lg-start mb-5">
              Have any questions?
            </h2>
            {/* Heading end*/}

            <Accordion flush defaultActiveKey="0">
              {faqsData.length > 0 &&
                faqsData.map((faq, index) => (
                  <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>{faq.question}</Accordion.Header>
                    <Accordion.Body
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    ></Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
          </div>
          <div
            className="col-lg-6 d-flex align-items-center justify-content-center order-0 order-lg-1 wow fadeIn"
            data-wow-delay="1s"
          >
            {" "}
            <img
              className="img-fluid"
              src="images/faq.png"
              title="FAQ"
              alt="faq"
            />{" "}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQs;
